<div class="headlines2" style="text-decoration: underline">Data Privacy</div>
<div
  style="max-width: 900px; margin: auto; font-size: medium; text-align: justify"
>
  <ol style="margin-top: 10px">
    <li style="margin-top: 10px">
      <span style="font-weight: bold">General Information</span><br />
      We take the protection of your personal data very seriously. This data
      privacy statement explains how we collect, process, and use your data when
      you use our website and web application. All data processing activities
      are carried out in compliance with the General Data Protection Regulation
      (GDPR) and other applicable laws.
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Data protection officer</span><br />
      The legal bases for the data protection are the General Data Protection
      Regulation (GDPR), the Federal Data Protection Act (BDSG), the Lower
      Saxony Data Protection Act (NdsDSG) and the Telemedia Act (TMG). The UMG
      declares that it complies with the applicable laws, in particular when
      processing personal data. <br /><br />
      The UMG Data Protection Officer can be contacted at: <br />
      Universitätsmedizin Göttingen <br />
      - Datenschutzbeauftragter -<br />
      37099 Göttingen <br />
      Germany <br />
      E-Mail: <a href="mailto:datenschutz@med.uni-goettingen.de">datenschutz@med.uni-goettingen.de</a><br />
      Phone: +49 (0)551 3922762<br />
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Data We Collect</span><br />
      When you use our web application, the following types of data may be
      collected: Uploaded Data: Data files you upload through the application.
      Log Data: Information such as IP address, browser type, operating system,
      referring URLs, and timestamps. Cookies: Small files stored on your device
      to enhance the functionality and usability of the website. See section 8
      for more information on cookies.
    </li>

    <li style="margin-top: 10px">
      <span style="font-weight: bold">Purpose of Data Processing</span><br />
      We collect and process your data for the following purposes: To provide
      and operate the web application. To enable data uploads and ensure secure
      storage. To respond to user inquiries and provide customer support. To
      analyze usage trends and improve the website’s functionality. To comply
      with legal obligations, including data retention requirements.
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Legal Basis for Processing</span><br />
      The legal basis for processing your data depends on the purpose: Consent
      (Article 6(1)(a) GDPR): For processing activities where you explicitly
      grant permission. Performance of a Contract (Article 6(1)(b) GDPR): For
      providing the requested services. Legitimate Interests (Article 6(1)(f)
      GDPR): For analytics and improving our services. Legal Obligation (Article
      6(1)(c) GDPR): To comply with applicable laws and regulations.
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Data Uploads</span><br />
      When you upload data via the web application: Uploaded files are processed
      securely and are accessible only to authorized personnel. We will not
      access or use your uploaded data for purposes other than providing the
      service unless required by law. Please ensure that you do not upload
      sensitive or unlawful content.
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Data Sharing</span><br />
      We will not share your personal data with third parties.
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Cookies and Analytics</span><br />
      We use the web analysis tool Matomo to enhance the functionality and
      usability of our website. You can configure your browser to reject cookies
      or notify you when cookies are being set. We may also use analytics tools
      to understand user behavior and improve the website. These tools anonymize
      data where possible.
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Data Retention</span><br />
      Uploaded data will be stored for the duration of your use of the
      application unless otherwise specified. Uploaded files are automatically
      deleted after 72 hours.
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Your Rights</span><br />
      You have the following rights regarding your personal data: Right to
      access (Article 15 GDPR). Right to rectification (Article 16 GDPR). Right
      to erasure ("right to be forgotten") (Article 17 GDPR). Right to
      restriction of processing (Article 18 GDPR). Right to data portability
      (Article 20 GDPR). Right to object to processing (Article 21 GDPR). Right
      to withdraw consent (Article 7(3) GDPR). To exercise these rights, please
      contact us at kevin.kornrumpf@bioinf.med.uni-goettingen.de. You also have the
      right to lodge a complaint with a supervisory authority.
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Data Security</span><br />
      We implement technical and organizational measures to ensure the security
      of your data and protect it against unauthorized access, alteration,
      disclosure, or destruction.
    </li>
    <li style="margin-top: 10px">
      <span style="font-weight: bold">Changes to This Privacy Policy</span
      ><br />
      We may update this privacy policy from time to time. The latest version
      will always be available on our website.
    </li>
  </ol>
</div>
